/* Sarah Ford — Treatments page: category filter, card reveal, sticky offsets */
(function () {
  'use strict';

  function measureHeader() {
    var header = document.querySelector('.sf-header');
    var h = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--sft-header-h', h + 'px');
    document.documentElement.style.scrollPaddingTop = (h + 84) + 'px';
  }

  function initFilter() {
    var rail = document.querySelector('[data-sft-filter]');
    if (!rail || rail.dataset.sftReady === '1') return;
    rail.dataset.sftReady = '1';

    var buttons = Array.prototype.slice.call(rail.querySelectorAll('button[data-cat]'));
    var count = document.querySelector('[data-sft-count]');
    var active = 'all';

    function apply() {
      var visible = 0;
      document.querySelectorAll('.sft-card').forEach(function (c) {
        var ok = active === 'all' || c.dataset.cat === active;
        c.style.display = ok ? '' : 'none';
        if (ok) visible++;
      });
      document.querySelectorAll('.sft-grid').forEach(function (g) {
        var any = Array.prototype.some.call(g.querySelectorAll('.sft-card'), function (c) { return c.style.display !== 'none'; });
        g.style.display = any ? '' : 'none';
        var h = g.previousElementSibling;
        if (h && h.classList.contains('sft-gh2')) h.style.display = any ? '' : 'none';
      });
      document.querySelectorAll('[data-sft-sec]').forEach(function (s) {
        var any = Array.prototype.some.call(s.querySelectorAll('.sft-card'), function (c) { return c.style.display !== 'none'; });
        s.style.display = any ? '' : 'none';
      });
      if (count) count.textContent = visible + ' treatment' + (visible === 1 ? '' : 's');
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        active = b.dataset.cat;
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.cat === active ? 'true' : 'false'); });
        apply();
      });
    });
    apply();
  }

  function initReveal() {
    var cards = document.querySelectorAll('.sft-card:not(.in)');
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = (i % 3 * 60) + 'ms';
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }

  function initAll() {
    measureHeader();
    initFilter();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('resize', measureHeader);
  document.addEventListener('shopify:section:load', initAll);
})();
